module.exports = __webpack_public_path__ + "static/img/0776.b650c65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0776.jpg
// module id = 114
// module chunks = 0